import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'

/**
 * @description: 全局配置表单模型
 * @return {*}
 */
export const getConfigFormModel = () => {
  return {
    // 保存额外辅助配置信息，用于创意组再次随机打乱分配
    recombineHelpers: {
      // 智能创意组分配表单，
      distributeForm: null
    },
    // 模板方案配置
    template: {
      adNumber: 1,
      accountAllocation: 1,
      projectAllocation: 1,
      modeAllocation: 1
    },
    accounts: [],
    planForm: {},
    budgetForm: {},
    targetings: [],
    creatives: [],
    creativeForm: {},
    descriptions: [],
    landingPages: []
  }
}

/**
 * @description: 获取创意表单模型
 * @return {*}
 */
export const getCreativeFormModel = () => {
  return {
    creative_name: '', // 创意组名称
    materialType: MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO], // 创意组的素材类型  4:视频 1:图片

    // 已选素材
    selectedMaterials: {
      video: [], // 视频
      image: [], // 图片
      image_list: []
    }
  }
}
